import React, { createElement } from 'react';
import Style from './index.module.scss';
import withHover from '@ifeng-fe/lowcode_tool/src/hoc/withHover'

export interface AtomTextProps {
    nodeId?: string
    style: object;
    content?: string;
}

const AtomText: React.FC<AtomTextProps> = (props) => {
    const { nodeId, style, content } = props;

    return content ? (
        <span id={nodeId} className={Style.wrap} style={style}>
            {content}
        </span>
    ) : (
        <span id={nodeId} className={Style.empty} style={style}>
            原子 - 文本组件 - 无内容展示
        </span>
    );
};

export default withHover(AtomText, false);
